import { setToDateMonthYearInWords } from "../../../helpers";

const ReturningCustomersChartLogic = () => {
  const xAxisFormatter = (tick) => {
    return setToDateMonthYearInWords(tick);
  };

  return {
    xAxisFormatter,
  };
};

export default ReturningCustomersChartLogic;
